
import {
  Injectable,
  OnDestroy,
  ComponentFactoryResolver
}                                     from '@angular/core';

import { Logger }                     from '@/util/logger';

import { AuthenticationService }      from './authentication.service';
import { JobWatcherService }          from './job.watcher.service';
import { KPIService }                 from './k.p.i.service';
import { BlobService }                from './blob.service';
import { AlertService }               from './alert.service';
import { ModalService }               from './modal.service';
import { TaskProgressService }        from "./task.progress.service";
import { ProjectService }             from "./project.service";
import { LineSimService }             from "./line.sim.service";
import { UUIDService }                from "./uuid.service";
import { UserService }                from "./user.service";
import { IdeService }                 from "./ide.service";
import { WindowService }              from "@/services/window.service";
import { DatabridgeService }          from "@/services/databridge.service";
import { LocoQueryService }           from "@/services/loco.query.service";
import { BigQueryService }            from "@/services/big.query.service";
import { StorageService }             from "@/services/storage.service";
import { ScalableWorkEngineService }  from "@/services/scalable.work.engine.service";

@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class ServiceManager
 *
 * Provides common access to all of our services.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
export class ServiceManager implements OnDestroy {

  /** clean up when service is destroyed */
  ngOnDestroy(): void {

    Logger.debug('[ServiceManager] destructing...');

  }

  /** standard constructor */
  constructor(
    public alerts:      AlertService,
    public auth:        AuthenticationService,
    public blobber:     BlobService,
    public cfr:         ComponentFactoryResolver,
    public kpi:         KPIService,
    public linesim:     LineSimService,
    public modals:      ModalService,
    public projects:    ProjectService,
    public taskMonitor: TaskProgressService,
    public users:       UserService,
    public uuid:        UUIDService,
    public watcher:     JobWatcherService,
    public ide:         IdeService,
    public windows:     WindowService,
    public databridge:  DatabridgeService,
    public locoquery:   LocoQueryService,
    public bigquery:    BigQueryService,
    public storage:     StorageService,
    public swe:         ScalableWorkEngineService
  ) {


  }




}
